import { useState } from 'react';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { Send, Instagram, Mail, MapPin, CheckCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      setSent(true);
      setForm({ name: '', email: '', message: '' });
    } catch {
      alert('Error al enviar el mensaje');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[var(--cream)]" data-testid="contact-page">
      <div className="bg-white border-b border-[var(--sage)]/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <h1 className="text-3xl sm:text-4xl font-bold text-[var(--dark)] mb-2">Contacto</h1>
          <p className="text-base text-[var(--dark)]/50">Estamos aqui para ayudarte</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid lg:grid-cols-2 gap-12">
          {/* Form */}
          <div className="bg-white rounded-2xl p-8 border border-[var(--sage)]/20">
            {sent ? (
              <div className="text-center py-12 space-y-4">
                <CheckCircle className="h-16 w-16 text-[var(--sage-dark)] mx-auto" />
                <h3 className="text-xl font-bold text-[var(--dark)]">Mensaje enviado!</h3>
                <p className="text-[var(--dark)]/50">Te responderemos lo antes posible.</p>
                <Button onClick={() => setSent(false)} variant="outline" className="rounded-full border-[var(--sage)]">Enviar otro mensaje</Button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-5">
                <div className="space-y-2">
                  <Label className="text-sm text-[var(--dark)]/70">Nombre</Label>
                  <Input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Tu nombre" className="rounded-xl border-[var(--sage)] h-11" required data-testid="contact-name" />
                </div>
                <div className="space-y-2">
                  <Label className="text-sm text-[var(--dark)]/70">Email</Label>
                  <Input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="tu@email.com" className="rounded-xl border-[var(--sage)] h-11" required data-testid="contact-email" />
                </div>
                <div className="space-y-2">
                  <Label className="text-sm text-[var(--dark)]/70">Mensaje</Label>
                  <Textarea value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} placeholder="Como podemos ayudarte?" className="rounded-xl border-[var(--sage)] min-h-[120px]" required data-testid="contact-message" />
                </div>
                <Button type="submit" disabled={loading} className="w-full h-12 bg-[var(--violet)] hover:bg-[var(--violet-dark)] text-white rounded-xl text-base font-semibold" data-testid="contact-submit">
                  <Send className="mr-2 h-4 w-4" /> {loading ? 'Enviando...' : 'Enviar mensaje'}
                </Button>
              </form>
            )}
          </div>

          {/* Info */}
          <div className="space-y-8">
            <div>
              <h3 className="text-xl font-bold text-[var(--dark)] mb-6">Otras formas de contactarnos</h3>
              <div className="space-y-5">
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-[var(--violet-light)] flex items-center justify-center flex-shrink-0">
                    <Instagram className="h-5 w-5 text-[var(--violet)]" />
                  </div>
                  <div>
                    <p className="font-medium text-[var(--dark)]">Instagram</p>
                    <a href="https://instagram.com/aurakbeauty" target="_blank" rel="noopener noreferrer" className="text-sm text-[var(--violet)]">@aurakbeauty</a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-[var(--sage-light)] flex items-center justify-center flex-shrink-0">
                    <Mail className="h-5 w-5 text-[var(--sage-dark)]" />
                  </div>
                  <div>
                    <p className="font-medium text-[var(--dark)]">Email</p>
                    <a href="mailto:info@aurakbeauty.com" className="text-sm text-[var(--violet)]">info@aurakbeauty.com</a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-[var(--violet-light)] flex items-center justify-center flex-shrink-0">
                    <MapPin className="h-5 w-5 text-[var(--violet)]" />
                  </div>
                  <div>
                    <p className="font-medium text-[var(--dark)]">Ubicacion</p>
                    <p className="text-sm text-[var(--dark)]/50">Puerto Rico</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
